import FormRegister from "../../common/security/FormRegister";

const Registro = () => {
    return (<>
        <FormRegister/>
    </>)
}
export default Registro;